"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _attendee = require("../../../actions/attendee");
function attendeeMicStatusChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId,
    isMuted = _ref2.isMuted;
  dispatch((0, _attendee.setAttendeeMuteStatus)(attendeeId, isMuted));
}
var _default = exports["default"] = attendeeMicStatusChanged;